class MachinePicker extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;

      if (this.dataset.requestType === 'collection') {
        console.log('Machine picker loaded from collection page');
      }

      this.selectedMachineContainer = this.querySelector('.selected-machine');
      this.mql = window.matchMedia('(max-width: 989px)');

      // if (this.selectedMachineContainer) {
      //   this.mainContent = document.querySelector('#MainContent');
      //   if (this.mainContent) {
      //     this.originalParent = this.selectedMachineContainer.parentElement;
      //     this.mobileContainer = document.createElement('div');
      //     this.mobileContainer.classList.add('machine-picker-top');

      //     this.mql.addEventListener('change', this.handleLayout.bind(this));
      //     this.handleLayout();
      //   }
      // }

      this.initMobileToggle();

      this.legend = this.form.querySelector('legend');
      this.details = this.form.querySelectorAll('details-disclosure, button');
      this._showDetails = false;

      this.submitButton = this.querySelector('button[type="submit"]');
      this.brandRadios = this.querySelectorAll('input[name="brand"]');
      this.machineOptionsContainer = this.querySelector('#machine-options-container');
      this.brandSummarySpan = this.querySelectorAll('details-disclosure summary span')[0];
      this.machineSummarySpan = this.querySelectorAll('details-disclosure summary span')[1];
      this.initialMachineSummaryText = this.machineSummarySpan.textContent;
      
      const attributeKeys = [
        'machine_id',
        'machine_brand',
        'machine_type',
        'suitable_tamper_size',
        'suitable_portafilter_size',
        'suitable_waterfilter_size',
        '_portafilter_size_id',
        '_tamper_size_id',
        '_waterfilter_size_id'
      ];

      this.hiddenInputs = attributeKeys.reduce((acc, key) => {
        acc[key] = this.form.querySelector(`input[name="attributes[${key}]"]`);
        return acc;
      }, {});
  
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.brandRadios.forEach(radio => {
        radio.addEventListener('change', this.onBrandChange.bind(this));
        // Prevent Safari from closing details when clicking radio/label
        radio.addEventListener('click', (e) => {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }, true); // Capture phase
        
        radio.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }, true);
        
        const label = radio.parentElement.querySelector('label');
        if (label) {
          label.addEventListener('click', (e) => {
            e.stopPropagation();
            e.stopImmediatePropagation();
          }, true); // Use capture phase to catch before details
          
          label.addEventListener('mousedown', (e) => {
            e.stopPropagation();
            e.stopImmediatePropagation();
          }, true);
          
          label.addEventListener('click', (e) => {
            e.stopPropagation();
            e.stopImmediatePropagation();
          });
        }
      });
      
      if (this.selectedMachineContainer) {
        this.changeButton = this.selectedMachineContainer.querySelector('button.link');
        this.changeButton.addEventListener('click', this.onChangeButtonClick.bind(this));
        this.resetButton = this.selectedMachineContainer.querySelector('button[type="reset"]');
        if (this.resetButton) {
          this.resetButton.addEventListener('click', this.onResetButtonClick.bind(this));
        }
      }

      // Monitor details element changes for Safari debugging
      this.setupDetailsMonitoring();
      
      this.updateSummaries();
      this.initializeMachineOptions();
      this.initializeDefaultBrand();
      this.updateSubmitButtonState();

      if (this.dataset.requestType === 'collection') {
        const portafilterSizeId = this.hiddenInputs._portafilter_size_id.value;
        const tamperSizeId = this.hiddenInputs._tamper_size_id.value;
        const waterfilterSizeId = this.hiddenInputs._waterfilter_size_id.value;

        if (portafilterSizeId && tamperSizeId && waterfilterSizeId) {
            console.log('Initial Portafilter Size ID:', portafilterSizeId);
            console.log('Initial Tamper Size ID:', tamperSizeId);
            console.log('Initial Waterfilter Size ID:', waterfilterSizeId);
        }
      }
    }

    connectedCallback() {
      if (this.dataset.requestType === 'collection') {
        customElements.whenDefined('facet-filters-form');
      }
    }

    getMachineFilterParams() {
      const machineParams = new URLSearchParams();
      if (this.dataset.requestType !== 'collection' || this.dataset.filteringEnabled !== 'true') {
        return machineParams;
      }
      const portafilterSizeId = this.hiddenInputs._portafilter_size_id.value;
      const tamperSizeId = this.hiddenInputs._tamper_size_id.value;
      const waterfilterSizeId = this.hiddenInputs._waterfilter_size_id.value;

      const portafilterInputs = this.querySelectorAll('input[name="filter.v.m.custom.geschikte_maten_portafilter"]');
      const tamperInputs = this.querySelectorAll('input[name="filter.v.m.custom.geschikte_maten_tamper"]');
      const waterfilterInputs = this.querySelectorAll('input[name="filter.v.m.custom.geschikte_maten_waterfilter"]');

      if (portafilterInputs.length === 0 || tamperInputs.length === 0 || waterfilterInputs.length === 0) {
        return machineParams;
      }

      const portafilterValues = new Set();
      if (portafilterSizeId) {
        portafilterSizeId.split(',').forEach(id => {
          if (id) portafilterValues.add(`gid://shopify/Metaobject/${id.trim()}`);
        });
      }
      portafilterInputs.forEach(input => {
        if (input.value && input.value.match(/(\d+)$/)) {
          portafilterValues.add(input.value);
        }
      });

      const tamperValues = new Set();
      if (tamperSizeId) {
        tamperSizeId.split(',').forEach(id => {
          if (id) tamperValues.add(`gid://shopify/Metaobject/${id.trim()}`);
        });
      }
      tamperInputs.forEach(input => {
        if (input.value && input.value.match(/(\d+)$/)) {
          tamperValues.add(input.value);
        }
      });

      const waterfilterValues = new Set();
      if (waterfilterSizeId) {
        waterfilterSizeId.split(',').forEach(id => {
          if (id) waterfilterValues.add(`gid://shopify/Metaobject/${id.trim()}`);
        });
      }
      waterfilterInputs.forEach(input => {
        if (input.value && input.value.match(/(\d+)$/)) {
          waterfilterValues.add(input.value);
        }
      });

      const machineFilterAlwaysGids = [
        'gid://shopify/Metaobject/388677140863',
        'gid://shopify/Metaobject/518276186495',
      ];
      machineFilterAlwaysGids.forEach((gid) => {
        portafilterValues.add(gid);
        tamperValues.add(gid);
        waterfilterValues.add(gid);
      });

      portafilterValues.forEach(value => {
        machineParams.append(portafilterInputs[0].name, value);
      });

      tamperValues.forEach(value => {
        machineParams.append(tamperInputs[0].name, value);
      });

      waterfilterValues.forEach(value => {
        machineParams.append(waterfilterInputs[0].name, value);
      });

      return machineParams;
    }

    initMobileToggle() {
      if (this.dataset.collapseOnMobile !== 'true') return;

      this.legend = this.form.querySelector('legend');
      this.details = this.form.querySelectorAll('details-disclosure, button');
      this.boundToggleDetails = this.toggleDetails.bind(this);

      if (this.legend && this.details.length > 0) {
        this.mql.addEventListener('change', this.handleCollapseBehavior.bind(this));
        this.handleCollapseBehavior();
      }
    }

    handleCollapseBehavior() {
      if (this.mql.matches) {
        this.legend.addEventListener('click', this.boundToggleDetails);
        this._showDetails = false;
        this.details.forEach(detail => detail.hidden = true);
        this.legend.style.cursor = 'pointer';
        this.legend.setAttribute('aria-expanded', 'false');
      } else {
        this.legend.removeEventListener('click', this.boundToggleDetails);
        this._showDetails = true;
        this.details.forEach(detail => detail.hidden = false);
        this.legend.style.cursor = 'default';
        this.legend.removeAttribute('aria-expanded');
      }
    }

    toggleDetails() {
      this._showDetails = !this._showDetails;
      this.details.forEach(detail => detail.hidden = !this._showDetails);
      this.legend.setAttribute('aria-expanded', this._showDetails);
    }

    initializeDefaultBrand() {
      if (this.hiddenInputs.machine_brand.value) return;

      const activeBrandId = this.dataset.activeBrandId;
      if (!activeBrandId) return;

      const brandRadio = this.querySelector(`input[name="brand"][value="${activeBrandId}"]`);
      if (brandRadio) {
        brandRadio.checked = true;
        brandRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    initializeMachineOptions() {
      const initialBrand = this.hiddenInputs.machine_brand.value;
      if (!initialBrand) return;

      const brandRadio = Array.from(this.brandRadios).find(radio => {
        const label = radio.parentElement.querySelector('label');
        return label && label.textContent === initialBrand;
      });

      if (brandRadio) {
        brandRadio.checked = true;
        const jsonScript = brandRadio.parentElement.querySelector('script[type="application/json"]');
        if (jsonScript) {
          try {
            const machines = JSON.parse(jsonScript.textContent);
            this.populateMachineOptions(machines);
            const initialMachineId = this.hiddenInputs.machine_id.value;
            if (initialMachineId) {
              const machineRadio = this.machineOptionsContainer.querySelector(`input[value="${initialMachineId}"]`);
              if (machineRadio) {
                machineRadio.checked = true;
              }
            }
          } catch (e) {
            console.error('Error parsing machine data:', e);
          }
        }
      }
    }

    updateSummaries() {
      const brand = this.hiddenInputs.machine_brand.value;
      const type = this.hiddenInputs.machine_type.value;
  
      if (brand) {
        this.brandSummarySpan.textContent = brand;
      }
      if (type) {
        this.machineSummarySpan.textContent = type;
      }
    }
  
  openForm() {
      this.selectedMachineContainer.hidden = true;
      this.form.hidden = false;
  }
  
  closeForm() {
    this.selectedMachineContainer.hidden = false;
    this.form.hidden = true;
  }

    onChangeButtonClick() {
      this.openForm();
      const collectionPage = this.closest('collection-page');
      if (collectionPage) {
        collectionPage.openFilters();
      }
    }
  
    onBrandChange(event) {
      const selectedBrandRadio = event.target;
      const jsonScript = selectedBrandRadio.parentElement.querySelector('script[type="application/json"]');
      const selectedLabel = selectedBrandRadio.parentElement.querySelector('label');
      
      const detailsElement = selectedBrandRadio.closest('details');
      
      // Clear the selection flag so details can close
      const brandDetails = this.querySelector('details-disclosure:first-of-type details');
      if (brandDetails && brandDetails.dataset.isSelectingRadio) {
        brandDetails.dataset.isSelectingRadio = 'false';
        if (brandDetails.dataset.selectingRadioTimeout) {
          clearTimeout(parseInt(brandDetails.dataset.selectingRadioTimeout));
          delete brandDetails.dataset.selectingRadioTimeout;
        }
      }
      
      if (selectedLabel) {
        this.brandSummarySpan.textContent = selectedLabel.textContent;
        if (this.hiddenInputs.machine_brand) {
          this.hiddenInputs.machine_brand.value = selectedLabel.textContent;
        }
      }
      this.machineSummarySpan.textContent = this.initialMachineSummaryText;
      
      // Close details after a short delay to ensure change event completes
      setTimeout(() => {
        if (detailsElement && detailsElement.hasAttribute('open')) {
          detailsElement.removeAttribute('open');
        }
      }, 200);
      
      let machines = [];
      if (jsonScript) {
        try {
          machines = JSON.parse(jsonScript.textContent);
        } catch (e) {
          console.error('Error parsing machine data:', e);
        }
      }
      this.populateMachineOptions(machines);
      this.updateSubmitButtonState();
    }
  
    populateMachineOptions(machines) {
      this.machineOptionsContainer.innerHTML = '';
      machines.forEach(machine => {
        if (!machine?.system?.id) {
          console.warn('Skipping invalid machine data:', machine);
          return;
        }

        const id = machine?.system?.id;
        const machineType = machine?.type_naam || '';
        const suitablePortafilterSize = machine?.geschikte_maat_portafilter?.value?.maat || '';
        const portafilterSizeId = machine?.geschikte_maat_portafilter?.value?.id || '';
        const tamperList = machine?.geschikte_maten_tamper?.value;
        let suitableTamperSize = '';
        let tamperSizeId = '';
        if (Array.isArray(tamperList) && tamperList.length) {
          suitableTamperSize = tamperList.map((t) => t.maat).filter(Boolean).join(', ');
          tamperSizeId = tamperList.map((t) => t.id).filter(Boolean).join(',');
        }
        const suitableWaterfilterSize =
          machine?.geschikte_maat_waterfilter?.value?.maat ||
          machine?.geschikte_maten_waterfilter?.value?.maat ||
          '';
        const waterfilterSizeId =
          machine?.geschikte_maat_waterfilter?.value?.id ||
          machine?.geschikte_maten_waterfilter?.value?.id ||
          '';
        
        const machineId = `machine_id_${id}`;
  
        const div = document.createElement('div');
        const input = document.createElement('input');
        input.type = 'radio';
        input.id = machineId;
        input.name = 'machine_selection';
        input.value = id;
        
        Object.assign(input.dataset, {
          machineType,
          suitablePortafilterSize,
          suitableTamperSize,
          suitableWaterfilterSize,
          portafilterSizeId,
          tamperSizeId,
          waterfilterSizeId
        });
  
        input.addEventListener('change', this.onMachineChange.bind(this));
        // Prevent Safari from closing details when clicking radio/label
        input.addEventListener('click', (e) => {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }, true); // Capture phase
        
        input.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }, true);
        
        const label = document.createElement('label');
        label.htmlFor = machineId;
        label.textContent = machineType;
        // Prevent Safari from closing details when clicking label
        label.addEventListener('click', (e) => {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }, true); // Use capture phase to catch before details
        
        label.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }, true);
        
        label.addEventListener('click', (e) => {
          e.stopPropagation();
          e.stopImmediatePropagation();
        });
        
        div.appendChild(input);
        div.appendChild(label);
        this.machineOptionsContainer.appendChild(div);
      });
    }
  
    onMachineChange(event) {
      const selectedRadio = event.target;
      this.machineSummarySpan.textContent = selectedRadio.dataset.machineType;
      
      const detailsElement = selectedRadio.closest('details');
      
      // Clear the selection flag so details can close
      const machineDetails = this.querySelector('details-disclosure:last-of-type details');
      if (machineDetails && machineDetails.dataset.isSelectingRadio) {
        machineDetails.dataset.isSelectingRadio = 'false';
        if (machineDetails.dataset.selectingRadioTimeout) {
          clearTimeout(parseInt(machineDetails.dataset.selectingRadioTimeout));
          delete machineDetails.dataset.selectingRadioTimeout;
        }
      }
      
      // Close details after a short delay to ensure change event completes
      setTimeout(() => {
        if (detailsElement && detailsElement.hasAttribute('open')) {
          detailsElement.removeAttribute('open');
        }
      }, 200);
      
      this.hiddenInputs.machine_id.value = selectedRadio.value;
      
      const attributeMap = {
          machine_type: 'machineType',
          suitable_tamper_size: 'suitableTamperSize',
          suitable_portafilter_size: 'suitablePortafilterSize',
          suitable_waterfilter_size: 'suitableWaterfilterSize',
          _portafilter_size_id: 'portafilterSizeId',
          _tamper_size_id: 'tamperSizeId',
          _waterfilter_size_id: 'waterfilterSizeId',
      };

      for (const [inputKey, datasetKey] of Object.entries(attributeMap)) {
          if (this.hiddenInputs[inputKey]) {
              this.hiddenInputs[inputKey].value = selectedRadio.dataset[datasetKey] || '';
          }
      }

      if (this.dataset.requestType === 'collection') {
        console.log('Portafilter Size ID:', selectedRadio.dataset.portafilterSizeId);
        console.log('Tamper Size ID:', selectedRadio.dataset.tamperSizeId);
        console.log('Waterfilter Size ID:', selectedRadio.dataset.waterfilterSizeId);
      }

      if (!this.submitButton) {
        this.submitSelection();
      }
      this.updateSubmitButtonState();
    }

    updateSubmitButtonState() {
      if (!this.submitButton) return;

      const brandSelected = this.form.querySelector('input[name="brand"]:checked');
      const machineSelected = this.form.querySelector('input[name="machine_selection"]:checked');

      this.submitButton.disabled = !(brandSelected && machineSelected);
    }
  
    submitSelection() {
      if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

      if (this.submitButton) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
      }

      const attributes = Object.keys(this.hiddenInputs).reduce((acc, key) => {
        if (this.hiddenInputs[key]) {
          acc[key] = this.hiddenInputs[key].value;
        }
        return acc;
      }, {});

      const body = { attributes };

      fetch('/cart/update.js', {...fetchConfig(), body: JSON.stringify(body) })
        .then((response) => response.json())
        .then((response) => {
          if (this.dataset.redirectUrl) {
            window.location.href = this.dataset.redirectUrl;
            return;
          }
          const modal = this.closest('modal-dialog');
          if (modal) {
            modal.hide();
          }

          if (this.dataset.requestType === 'collection') {
            if (this.dataset.filteringEnabled === 'true') {
              this.updateFilters();
            }
            this.refreshMachinePicker();
          } else {
            this.refreshSection(this.dataset.parentSectionId);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
          }
        });
    }
  
    onSubmitHandler(event) {
      event.preventDefault();
      this.submitSelection();
    }

    onResetButtonClick(event) {
      event.preventDefault();

      const collectionPage = this.closest('collection-page');
      if (collectionPage) {
        collectionPage.openFilters();
      }
  
      const attributes = Object.keys(this.hiddenInputs).reduce((acc, key) => {
        acc[key] = '';
        return acc;
      }, {});
  
      const body = { attributes };
  
      fetch('/cart/update.js', { ...fetchConfig(), body: JSON.stringify(body) })
        .then(response => response.json())
        .then(() => {
            if (this.dataset.requestType === 'collection' && this.dataset.filteringEnabled === 'true') {
                const params = new URLSearchParams(window.location.search);
                params.delete('filter.v.m.custom.geschikte_maten_portafilter');
                params.delete('filter.v.m.custom.geschikte_maten_tamper');
                params.delete('filter.v.m.custom.geschikte_maten_waterfilter');
                if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
                    FacetFiltersForm.renderPage(params.toString(), null, false);
                }
            }

            if (this.dataset.requestType === 'collection') {
              this.refreshMachinePicker();
            } else {
              this.refreshSection(this.dataset.parentSectionId);
            }
        })
        .catch(e => console.error(e));
    }
 
    refreshMachinePicker() {
      const params = new URLSearchParams(window.location.search);
      params.set('section_id', this.dataset.sectionId);
  
      const url = `${window.location.pathname}?${params.toString()}`;
  
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const newMachinePicker = html.querySelector('machine-picker');
  
          if (newMachinePicker) {
            this.replaceWith(newMachinePicker);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    updateFilters() {
      if (this.dataset.requestType !== 'collection') return;


      const portafilterSizeId = this.hiddenInputs._portafilter_size_id.value;
      const tamperSizeId = this.hiddenInputs._tamper_size_id.value;
      const waterfilterSizeId = this.hiddenInputs._waterfilter_size_id.value;

      const portafilterInputs = this.querySelectorAll('input[name="filter.v.m.custom.geschikte_maten_portafilter"]');
      const tamperInputs = this.querySelectorAll('input[name="filter.v.m.custom.geschikte_maten_tamper"]');
      const waterfilterInputs = this.querySelectorAll('input[name="filter.v.m.custom.geschikte_maten_waterfilter"]');

      if (portafilterInputs.length === 0 || tamperInputs.length === 0 || waterfilterInputs.length === 0) {
        console.error('Machine Picker: Filter inputs not found. Make sure they exist inside the <machine-picker> element.');
        return;
      }

      const params = new URLSearchParams(
        typeof FacetFiltersForm !== 'undefined' ? FacetFiltersForm.searchParamsPrev : window.location.search
      );

      params.delete(portafilterInputs[0].name);
      params.delete(tamperInputs[0].name);
      params.delete(waterfilterInputs[0].name);

      const portafilterValues = new Set();
      if (portafilterSizeId) {
        portafilterSizeId.split(',').forEach(id => {
          if (id) portafilterValues.add(`gid://shopify/Metaobject/${id.trim()}`);
        });
      }
      portafilterInputs.forEach(input => {
        if (input.value && input.value.match(/(\d+)$/)) {
          portafilterValues.add(input.value);
        }
      });

      const tamperValues = new Set();
      if (tamperSizeId) {
        tamperSizeId.split(',').forEach(id => {
          if (id) tamperValues.add(`gid://shopify/Metaobject/${id.trim()}`);
        });
      }
      tamperInputs.forEach(input => {
        if (input.value && input.value.match(/(\d+)$/)) {
          tamperValues.add(input.value);
        }
      });

      const waterfilterValues = new Set();
      if (waterfilterSizeId) {
        waterfilterSizeId.split(',').forEach(id => {
          if (id) waterfilterValues.add(`gid://shopify/Metaobject/${id.trim()}`);
        });
      }
      waterfilterInputs.forEach(input => {
        if (input.value && input.value.match(/(\d+)$/)) {
          waterfilterValues.add(input.value);
        }
      });

      const machineFilterAlwaysGids = [
        'gid://shopify/Metaobject/388677140863',
        'gid://shopify/Metaobject/518276186495',
      ];
      machineFilterAlwaysGids.forEach((gid) => {
        portafilterValues.add(gid);
        tamperValues.add(gid);
        waterfilterValues.add(gid);
      });

      portafilterValues.forEach(value => {
        params.append(portafilterInputs[0].name, value);
      });

      tamperValues.forEach(value => {
        params.append(tamperInputs[0].name, value);
      });

      waterfilterValues.forEach(value => {
        params.append(waterfilterInputs[0].name, value);
      });

      console.log('Machine Picker: Applying filters with params:', params.toString());

      if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
        FacetFiltersForm.renderPage(params.toString(), null, false);
      } else {
        console.error('Machine Picker: FacetFiltersForm.renderPage is not available.');
      }
    }

  refreshSection(oldSectionId) {
    const params = new URLSearchParams(window.location.search);
    params.set('section_id', this.dataset.sectionId);

    if (!params.has('variant')) {
      const variantInput =
        this.closest('.shopify-section')?.querySelector('product-form input[name="id"]') ||
        document.querySelector('product-form input[name="id"]');
      if (variantInput && variantInput.value) {
        params.set('variant', variantInput.value);
      }
    }

    const url = `?${params.toString()}`;
    console.log('Machine Picker: Refreshing section with URL:', url);
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          console.log(html);
          const newSection = html.querySelector('.shopify-section');
          const oldSection = document.getElementById(`shopify-section-${oldSectionId}`);
          console.log(oldSectionId);

          console.log(newSection);
          console.log(oldSection);
          if (newSection && oldSection) {
                oldSection.innerHTML = newSection.innerHTML;
            
          }
        });
    }

    setupDetailsMonitoring() {
      const brandDetails = this.querySelector('details-disclosure:first-of-type details');
      const machineDetails = this.querySelector('details-disclosure:last-of-type details');
      
      if (brandDetails) {
        const brandObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              const isNowOpen = brandDetails.hasAttribute('open');
              const wasOpen = mutation.oldValue !== null;
              const justClosed = wasOpen && !isNowOpen;
              const isSelectingRadio = brandDetails.dataset.isSelectingRadio === 'true';
              
              // If details just closed and we're selecting a radio, re-open it
              if (justClosed && isSelectingRadio) {
                requestAnimationFrame(() => {
                  brandDetails.setAttribute('open', '');
                });
              }
            }
          });
        });
        brandObserver.observe(brandDetails, {
          attributes: true,
          attributeOldValue: true,
          attributeFilter: ['open']
        });
        
        // Monitor clicks on the details element itself
        brandDetails.addEventListener('click', (e) => {
          // If clicking on radio, label, or inside radio-option, stop propagation
          if (e.target.type === 'radio' || 
              e.target.tagName === 'LABEL' || 
              e.target.closest('.radio-option')) {
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        }, true);
        
        // Also add click handler on the content area itself
        const brandContentArea = brandDetails.querySelector('.machine-options');
        if (brandContentArea) {
          brandContentArea.addEventListener('click', (e) => {
            // Stop propagation to prevent summary from receiving the click
            if (e.target.type === 'radio' || e.target.tagName === 'LABEL' || e.target.closest('.radio-option')) {
              e.stopPropagation();
            }
          }, true);
        }
        
        // Also monitor clicks on the summary
        const brandSummary = brandDetails.querySelector('summary');
        if (brandSummary) {
          // Use mousedown instead of click - Safari handles this differently
          brandSummary.addEventListener('mousedown', (e) => {
            const machineOptions = brandDetails.querySelector('.machine-options');
            const isClickInsideContent = machineOptions && (
              machineOptions.contains(e.target) || 
              e.target.closest('.radio-option') ||
              e.target.closest('label') ||
              e.target.closest('input[type="radio"]')
            );
            
            // If click originated from inside content area, prevent toggle
            if (isClickInsideContent) {
              e.preventDefault();
              e.stopImmediatePropagation();
              return false;
            }
          }, true);
          
          brandSummary.addEventListener('click', (e) => {
            const machineOptions = brandDetails.querySelector('.machine-options');
            const isClickInsideContent = machineOptions && (
              machineOptions.contains(e.target) || 
              e.target.closest('.radio-option') ||
              e.target.closest('label') ||
              e.target.closest('input[type="radio"]')
            );
            
            // Only allow toggle if clicking directly on summary or its direct children (not content)
            const isDirectSummaryClick = e.target === brandSummary || 
                                        e.target.parentElement === brandSummary ||
                                        (e.target.closest('summary') === brandSummary && !isClickInsideContent);
            
            if (!isDirectSummaryClick) {
              e.preventDefault();
              e.stopImmediatePropagation();
              return false;
            }
          }, true);
        }
        
        // Set flag when clicking on radio/label
        brandDetails.addEventListener('mousedown', (e) => {
          if (e.target.type === 'radio' || e.target.tagName === 'LABEL' || e.target.closest('.radio-option')) {
            brandDetails.dataset.isSelectingRadio = 'true';
            if (brandDetails.dataset.selectingRadioTimeout) {
              clearTimeout(parseInt(brandDetails.dataset.selectingRadioTimeout));
            }
            const timeout = setTimeout(() => {
              brandDetails.dataset.isSelectingRadio = 'false';
              delete brandDetails.dataset.selectingRadioTimeout;
            }, 1000);
            brandDetails.dataset.selectingRadioTimeout = timeout.toString();
          }
        }, true);
        
        // Also set flag on click
        brandDetails.addEventListener('click', (e) => {
          if (e.target.type === 'radio' || e.target.tagName === 'LABEL' || e.target.closest('.radio-option')) {
            brandDetails.dataset.isSelectingRadio = 'true';
            if (brandDetails.dataset.selectingRadioTimeout) {
              clearTimeout(parseInt(brandDetails.dataset.selectingRadioTimeout));
            }
            const timeout = setTimeout(() => {
              brandDetails.dataset.isSelectingRadio = 'false';
              delete brandDetails.dataset.selectingRadioTimeout;
            }, 1000);
            brandDetails.dataset.selectingRadioTimeout = timeout.toString();
          }
        }, true);
      }
      
      if (machineDetails) {
        const machineObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              const isNowOpen = machineDetails.hasAttribute('open');
              const wasOpen = mutation.oldValue !== null;
              const justClosed = wasOpen && !isNowOpen;
              const isSelectingRadio = machineDetails.dataset.isSelectingRadio === 'true';
              
              // If details just closed and we're selecting a radio, re-open it
              if (justClosed && isSelectingRadio) {
                requestAnimationFrame(() => {
                  machineDetails.setAttribute('open', '');
                });
              }
            }
          });
        });
        machineObserver.observe(machineDetails, {
          attributes: true,
          attributeOldValue: true,
          attributeFilter: ['open']
        });
        
        // Set flag when clicking on machine radio/label
        machineDetails.addEventListener('mousedown', (e) => {
          if (e.target.type === 'radio' || e.target.tagName === 'LABEL' || e.target.closest('div')?.querySelector('input[type="radio"]')) {
            machineDetails.dataset.isSelectingRadio = 'true';
            if (machineDetails.dataset.selectingRadioTimeout) {
              clearTimeout(parseInt(machineDetails.dataset.selectingRadioTimeout));
            }
            const timeout = setTimeout(() => {
              machineDetails.dataset.isSelectingRadio = 'false';
              delete machineDetails.dataset.selectingRadioTimeout;
            }, 1000);
            machineDetails.dataset.selectingRadioTimeout = timeout.toString();
          }
        }, true);
        
        // Also set flag on click
        machineDetails.addEventListener('click', (e) => {
          if (e.target.type === 'radio' || e.target.tagName === 'LABEL' || e.target.closest('div')?.querySelector('input[type="radio"]')) {
            machineDetails.dataset.isSelectingRadio = 'true';
            if (machineDetails.dataset.selectingRadioTimeout) {
              clearTimeout(parseInt(machineDetails.dataset.selectingRadioTimeout));
            }
            const timeout = setTimeout(() => {
              machineDetails.dataset.isSelectingRadio = 'false';
              delete machineDetails.dataset.selectingRadioTimeout;
            }, 1000);
            machineDetails.dataset.selectingRadioTimeout = timeout.toString();
          }
        }, true);
      }
    }

    handleLayout() {
      if (!this.selectedMachineContainer || !this.mainContent) return;

      if (this.mql.matches) {
        if (this.selectedMachineContainer.parentElement !== this.mobileContainer) {
          this.mobileContainer.appendChild(this.selectedMachineContainer);
          this.mainContent.prepend(this.mobileContainer);
        }
      } else {
        if (this.selectedMachineContainer.parentElement === this.mobileContainer) {
          this.originalParent.prepend(this.selectedMachineContainer);
          if (this.mobileContainer.parentElement) {
            this.mainContent.removeChild(this.mobileContainer);
          }
        }
      }
    }
  }
  
  customElements.define('machine-picker', MachinePicker);
  
  